import PayloadParameters from '@/app/sales_analysis/models/PayloadParameters'

class Fact {
  constructor (factName, type = 'table') {
    this.type = type
    this.name = factName
  }
}

export default class PayloadParametersBuilder {
  constructor ({ metrics, factTableName, filters, limit = 0, offset = 0 }) {
    this.limit = limit
    this.offset = offset
    this.fact = new Fact(factTableName)
    this.metrics = metrics
    this.storeFilters = { ...filters.selectedStoreFilters }
    this.productFilters = { ...filters.selectedProductFilters }
  }

  _buildSorting () {
    const defaultSortField = this.metrics.normal[0]
    this.sort = { field: defaultSortField, dir: 'DESC' }
  }

  _buildFilters (payloadParametersByStrategy) {
    const storeFilterField = Object.keys(payloadParametersByStrategy.storeFilters)[0]
    const productFilterField = Object.keys(payloadParametersByStrategy.productFilters)[0]

    this.storeFilters[storeFilterField] = payloadParametersByStrategy.storeFilters[storeFilterField]
    this.productFilters[productFilterField] = payloadParametersByStrategy.productFilters[productFilterField]
  }

  build (strategyBuilder) {
    if (!('metrics' in this)) {
      throw new Error('Faltan las metricas')
    }

    this._buildSorting()
    const payloadParametersByStrategy = strategyBuilder.build()
    this._buildFilters(payloadParametersByStrategy)
    const payloadParameters = new PayloadParameters({ ...payloadParametersByStrategy, ...this })
    return payloadParameters
  }
}



// WEBPACK FOOTER //
// ./src/app/sales_analysis/models/PayloadParametersBuilder.js